import { addQueryArgs } from '@wordpress/url';

/**
 * Fetches data from the WordPress REST API.
 * Using instead of apiFetch to avoid nonce injection/headers.
 *
 * @param options {Object} -  The options for the fetch.
 * @returns {Promise<any[]>} - The data from the API.
 */
const apiFetch = async (options: { path: string }): Promise<any[]> => {
  try {
    // Construct the apiBase and strip trailing slashes.
    const apiBase = window.plariumNicknameGenerator?.restUrl
      ? window.plariumNicknameGenerator.restUrl.replace(/\/$/, '')
      : `${window.location.origin.replace(/\/$/, '')}/wp-json`;

    // Construct the url and strip leading slashes.
    const path = options.path.replace(/^\//, '');

    // Fetch the data.
    const response = await fetch(`${apiBase}/${path}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Fetch error:', error);
    return [];
  }
};

const createGenerateNicknameApi = () => {
  const cacheNickNames: { [key: string]: any[] } = {};

  async function makeRequestAndPutToCache(url: string) {
    const data: any[] = await apiFetch({
      path: url,
    });
    cacheNickNames[url] = [...(cacheNickNames[url] || []), ...data];
  }

  function getFromCache(url: string) {
    const isCacheEmpty = !(cacheNickNames[url] && cacheNickNames[url].length);

    if (isCacheEmpty) {
      return;
    }

    const head = cacheNickNames[url][0];
    const tails = cacheNickNames[url].slice(1);
    cacheNickNames[url] = tails;
    return head;
  }

  return async (group: string, gender: string) => {
    const url = addQueryArgs('/plarium-mini-apps/v1/generator', { group, gender });
    const cached = getFromCache(url);

    if (cached) {
      return cached;
    }

    await makeRequestAndPutToCache(url);
    return getFromCache(url);
  };
};

export const getGeneratedNickname = createGenerateNicknameApi();
